export enum DialogPosition {
  Center = "center",
  Top = "top",
  Bottom = "bottom",
  Left = "left",
  Right = "right",
  TopLeft = "topleft",
  TopRight = "topright",
  BottomLeft = "bottomleft",
  BottomRight = "bottomright"
}
